import React from 'react';

import clsx from 'clsx';

import { ReactComponent as PlusIcon } from 'assets/icons/PlusIcon.svg';

import { Button } from 'components/_basic/Button/Button';

import { IAddButtonProps } from './types';

import styles from './AddButton.module.scss';

export const AddButton: React.FC<IAddButtonProps> = ({ canAddMore, children, disabled, ...props }) => {
  if (!canAddMore) {
    return null;
  }

  return (
    <Button {...props} className={clsx(styles.addButton, props.className)} variant="text" disabled={disabled}>
      <PlusIcon />
      {children}
    </Button>
  );
};
